module.exports = __webpack_public_path__ + "static/media/background.deeea20b.jpg";